module.exports = __webpack_public_path__ + "img/1.4fe92550.webp";